import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'VARIABLES';

const fields = [  
  'ORGANIZATION',
  'APP_NAME',
  'TAG_LINE',
  'EMAIL',
  'DOMAIN',
  'PLACE',
  'SUPERIOR_NAME',
  'CITIZEN',
  'MANILA_ZOO_LINK',
  'MAP_LINK_EMBED',
  'LOCATION_NAME',
  'HOTLINE_1',
  'HOTLINE_2',
  'COVID_HOTLINE',
  'HELPDESK_1',
  'HELPDESK_2',
  'HELPDESK_3',
  'HELPDESK_SCHEDULE_1',
  'HELPDESK_SCHEDULE_2',
  'TITLE_SITE',
  'APPSTORE_BANNER_LINK',
  'PLAYSTORE_BANNER_LINK',
  'FOOTER_LINK',
];

const fields_core = [
  'TITLE',
  'CITIZEN_ID',
  'LGU_NAME',
]

function Variables({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
}) {
  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, [...fields, ...fields_core])),
      });
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, [...fields, ...fields_core])),
    });
  };

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="row">
          <div className="col-12">
            <label className="cms-label my-2">SITE: </label>
            <hr className="hr" />
            <div className="row">
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TITLE_SITE', label: 'TITLE_SITE' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'ORGANIZATION', label: 'ORGANIZATION' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'APP_NAME', label: 'APP_NAME' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TAG_LINE', label: 'TAG_LINE' },
                  { required: true, type: 'text' }
                )}
              </div>
              
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'DOMAIN', label: 'DOMAIN' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'SUPERIOR_NAME', label: 'SUPERIOR_NAME' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CITIZEN', label: 'CITIZEN' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>HEADER</b>
              </div>
              <div className="col-6 group-cms-color form-input-group">
                {createInput(
                  { key: 'MANILA_ZOO_LINK', label: 'MANILA ZOO LINK' },
                  { type: 'text'}
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>LOCATION</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'MAP_LINK_EMBED', label: 'MAP_LINK_EMBED' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'LOCATION_NAME', label: 'LOCATION_NAME' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>HOTLINE</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HOTLINE_1', label: 'HOTLINE_1' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HOTLINE_2', label: 'HOTLINE_2' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'COVID_HOTLINE', label: 'COVID_HOTLINE' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>HELPDESK</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HELPDESK_1', label: 'HELPDESK_1' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HELPDESK_2', label: 'HELPDESK_2' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HELPDESK_3', label: 'HELPDESK_3' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'EMAIL', label: 'EMAIL' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HELPDESK_SCHEDULE_1', label: 'HELPDESK_SCHEDULE_1' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'HELPDESK_SCHEDULE_2', label: 'HELPDESK_SCHEDULE_2' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>AD BANNER LINKS</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'PLAYSTORE_BANNER_LINK', label: 'PLAYSTORE_BANNER_LINK' },
                  { required: false, type: 'url' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'APPSTORE_BANNER_LINK', label: 'APPSTORE_BANNER_LINK' },
                  { required: false, type: 'url' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>FOOTER</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'FOOTER_LINK', label: 'FOOTER_LINK' },
                  { required: false, type: 'url' }
                )}
              </div>
            </div>
          </div>
          
          <div className="col-12">
            <label className="cms-label my-2">CORE: </label>
            <hr className="hr" />
            <div className="row">
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TITLE', label: 'TITLE' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CITIZEN_ID', label: 'CITIZEN_ID' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'LGU_NAME', label: 'LGU_NAME' },
                  { required: true, type: 'text' }
                )}
              </div>
            </div>
          </div>
          
        </div>
        <div className="d-flex justify-content-center">
          <button
            // disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Variables.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Variables);
